<template>
  <div
    v-if="item.status === 'RUNNING'"
    class="flex-0 bg-ontick-steel-100 dark:bg-ontick-steel-500 rounded-b-lg"
  >
    <div class="flex justify-between px-4 py-1">
      <p
        content="Ganho máximo diário atingido"
        v-tippy="{ arrow: true, theme: 'green' }"
        :class="item.mask_gain ? 'text-ontick-green-600' : 'text-gray-500'"
        class="status_card"
      >
        GAIN
      </p>
      <p
        content="Perda máxima diária atingida"
        v-tippy="{ arrow: true, theme: 'green' }"
        :class="item.mask_loss ? 'text-ontick-red-600' : 'text-gray-500'"
        class="status_card"
      >
        LOSS
      </p>
      <p
        content="Horário limite atingido"
        v-tippy="{ arrow: true, theme: 'green' }"
        :class="item.mask_time ? 'text-ontick-blue-500' : 'text-gray-500'"
        class="status_card"
      >
        TEMPO
      </p>
      <p
        content="Quantidade máxima de operações atingida"
        v-tippy="{ arrow: true, theme: 'green' }"
        :class="item.mask_limit ? 'text-ontick-pink-500' : 'text-gray-500'"
        class="status_card"
      >
        LIMITE
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object },
  },
};
</script>

<style lang="scss" scoped>
.label_card {
  @apply text-xs text-gray-500 dark:text-gray-400;
}
.status_card {
  @apply text-center text-xs font-semibold;
}
</style>
